// Full-width search panel (snippets/sivana-search.liquid). Opens from the header's search icon and the
// mobile menu's search field. Typing fetches live results through Shopify's predictive search, rendered
// by sections/sivana-search-results.liquid, and swaps them in below the field.
(() => {
  const panel = document.querySelector('[data-sivana-search]');
  if (!panel || panel.dataset.ready) return;
  panel.dataset.ready = 'true';
  const root = window.Shopify?.routes?.root || '/';
  const input = panel.querySelector('[data-search-input]');
  const clear = panel.querySelector('[data-search-clear]');
  const defaults = panel.querySelector('[data-search-default]');
  const live = panel.querySelector('[data-search-live]');
  const cache = new Map();
  let timer;
  let controller;
  let trigger = null;

  const showDefault = () => {
    live.hidden = true;
    live.innerHTML = '';
    defaults.hidden = false;
  };

  const render = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const results = doc.querySelector('[data-sr-results]');
    if (!results) return;
    live.replaceChildren(results);
    live.hidden = false;
    defaults.hidden = true;
  };

  const search = async (term) => {
    const query = term.trim();
    if (!query) return showDefault();
    if (cache.has(query)) return render(cache.get(query));
    controller?.abort();
    controller = new AbortController();
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,query',
      'resources[limit]': '10',
      'resources[options][unavailable_products]': 'last',
      section_id: 'sivana-search-results',
    });
    panel.classList.add('is-loading');
    try {
      const response = await fetch(`${root}search/suggest?${params}`, { signal: controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      cache.set(query, html);
      if (input.value.trim() === query) render(html);
    } catch (error) {
      if (error.name !== 'AbortError') showDefault();
    } finally {
      panel.classList.remove('is-loading');
    }
  };

  input.addEventListener('input', () => {
    clear.hidden = !input.value;
    clearTimeout(timer);
    timer = setTimeout(() => search(input.value), 200);
  });
  clear.addEventListener('click', () => {
    input.value = '';
    clear.hidden = true;
    showDefault();
    input.focus();
  });

  const open = (from) => {
    trigger = from || null;
    document.documentElement.classList.add('sivana-search-open');
    panel.classList.remove('is-closing');
    panel.showModal();
    requestAnimationFrame(() => input.focus());
  };
  const close = () => {
    if (!panel.open || panel.classList.contains('is-closing')) return;
    const finish = () => {
      panel.classList.remove('is-closing');
      panel.close();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else {
      panel.classList.add('is-closing');
      setTimeout(finish, 180);
    }
  };
  panel.addEventListener('close', () => {
    document.documentElement.classList.remove('sivana-search-open');
    trigger?.focus?.({ preventScroll: true });
  });
  // Escape closes the panel even while typing (a search field would otherwise only clear itself).
  panel.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    close();
  });
  panel.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });
  panel.addEventListener('click', (event) => {
    if (event.target === panel || event.target.closest('[data-search-close]')) close();
  });

  // Header search icon (Horizon's search modal) and the mobile menu's search field open this panel.
  window.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.search-action button, [data-sivana-search-open]');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.SivanaMenu?.close();
      open(button);
    },
    true
  );

  window.SivanaSearch = { open, close };
})();
